import batchNumberModel from './batchNumberModel.vue'
export default batchNumberModel



// WEBPACK FOOTER //
// ./src/components/batchNumberModel/index.js